import React, { useEffect, useState } from 'react';
import Header from '../../Components/Header/Header';
import InvoicePage from '../invoice/InvoicePage';
import AssignmentDetails from '../AssignmentDetails/AssignmentDetails';
import VehicleConditionReport from '../VehicleConditionReport/VehicleConditionReport';
import PersonalProperty from '../PersonalProperty/PersonalProperty';
import { useParams } from 'react-router-dom';
import { getUserInfoFromSession } from '../../Services/session.mgmt';
import './Maintab.css';
import { AssignmentService } from '../../Services/AssignmentService';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
function Maintab() {
  const { teamWrkBpiNb } = useParams();

  // ✅ Guard: parse to number, null if empty/invalid
  const parsedBpiNb = teamWrkBpiNb && !isNaN(teamWrkBpiNb) ? Number(teamWrkBpiNb) : null;

  const userInfo = getUserInfoFromSession();
  const [assignmentStatus, setAssignmentStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(1);
  const [prodCd, setProdCd] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    // ✅ Don't call API if bpiNb is invalid
    if (!parsedBpiNb) {
      console.warn('Invalid or missing teamWrkBpiNb:', teamWrkBpiNb);
      setLoading(false);

      Swal.fire({
        width: '500px',
        title: 'warning',
        position: 'top',
        text: 'Your  Session  is expired please navigate from ' +
          'summary list',
        color: '#00095b',
        iconColor: '#00095b',
        icon: 'warning',
        confirmButtonText: 'OK',
        confirmButtonColor: '#00095b',
      });
      navigate(`/outstandingAssignment`);
      return;
    }

    const fetchAssignmentStatus = async () => {
      try {
        const repoAssignmentStatusInfo = await AssignmentService.getRepoAssignmentStatusInfo(
          parsedBpiNb,
          userInfo.cntrctrNb
        );

        const cntrctrActnCd = repoAssignmentStatusInfo.data.result.repoAssignmentStatus[0].cntrctrActnCd;
        const csrActnCd = repoAssignmentStatusInfo.data.result.repoAssignmentStatus[0].csrActnCd;

        if (cntrctrActnCd === 'H' || csrActnCd === 'H') {
          setAssignmentStatus('H');
        } else if (cntrctrActnCd === 'G' || csrActnCd === 'G') {
          setAssignmentStatus('G');
        } else if (cntrctrActnCd === 'A' || csrActnCd === 'A') {
          setAssignmentStatus('A');
        }

        const assignmentInfoResponse = await AssignmentService.getAssignmentInfo(parsedBpiNb, userInfo.cntrctrNb);
        setProdCd(assignmentInfoResponse.data[0].prodCd);
        setLoading(false);
      } catch (err) {
        console.error('Error Fetching Assignment Status:', err);
        setLoading(false); // ✅ Stop loading on error too
      }
    };

    fetchAssignmentStatus();
  }, [parsedBpiNb, userInfo.cntrctrNb]);

  const handleContinue = (tabCode) => {
    setActiveTab((prevTab) => (prevTab < 4 ? prevTab + 1 : tabCode));
  };

  // ✅ Handle invalid bpiNb before loading screen
  if (!parsedBpiNb) {
    return (
      <>
        <Header heading="" />
        <br />
        <p style={{ color: 'red', textAlign: 'center' }}>
          Invalid or missing Assignment Number. Please click on Summary button to navigate from the assignments list.
        </p>
      </>
    );
  }

  if (loading) {
    return (
      <>
        <Header heading="" />
        <br />
        Loading...
      </>
    );
  }

  return (
    <div>
      <Header heading="" />
      <div className="tabs">
        <h3 id="tablist-1"> </h3>
        <div role="tablist" aria-labelledby="tablist-1" className="manual" style={{ textAlign: 'center' }}>
          <button id="tab-1" type="button" role="tab" aria-selected={activeTab === 1} aria-controls="tabpanel-1" onClick={() => setActiveTab(1)}>
            <span className="focus">Assignment Details</span>
          </button>
          <button id="tab-2" type="button" role="tab" aria-selected={activeTab === 2} aria-controls="tabpanel-2" onClick={() => setActiveTab(2)}>
            <span className="focus">VCR</span>
          </button>
          <button id="tab-3" type="button" role="tab" aria-selected={activeTab === 3} aria-controls="tabpanel-3" onClick={() => setActiveTab(3)}>
            <span className="focus">Invoice</span>
          </button>
          <button id="tab-4" type="button" role="tab" aria-selected={activeTab === 4} aria-controls="tabpanel-4" onClick={() => setActiveTab(4)}>
            <span className="focus">Personal Property</span>
          </button>
        </div>

        <div id="tabpanel-1" role="tabpanel" aria-labelledby="tab-1" className={activeTab === 1 ? '' : 'is-hidden'}>
          <AssignmentDetails bpiNo={parsedBpiNb} onContinue={handleContinue} activeTab={activeTab} />
        </div>
        <div id="tabpanel-2" role="tabpanel" aria-labelledby="tab-2" className={activeTab === 2 ? '' : 'is-hidden'}>
          <VehicleConditionReport bpiNo={parsedBpiNb} onContinue={handleContinue} status={assignmentStatus} activeTab={activeTab} />
        </div>
        <div id="tabpanel-3" role="tabpanel" aria-labelledby="tab-3" className={activeTab === 3 ? '' : 'is-hidden'}>
          <InvoicePage bpiNo={parsedBpiNb} onContinue={handleContinue} status={assignmentStatus} activeTab={activeTab} prodCd={prodCd} />
        </div>
        <div id="tabpanel-4" role="tabpanel" aria-labelledby="tab-4" className={activeTab === 4 ? '' : 'is-hidden'}>
          <PersonalProperty bpiNo={parsedBpiNb} onContinue={handleContinue} status={assignmentStatus} activeTab={activeTab} />
        </div>
      </div>
      <div className="fmc-bottom-banner__content center copy-rightbanner">
        Copyright &copy; 2024 Ford Motor Credit Company. All Rights Reserved
      </div>
    </div>
  );
}

export default Maintab;
